/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sms_HintInputs */

const cs_sms_hint = /** @type {(inputs: Sms_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav brány a testovací odeslání (admin).`)
};

const en_sms_hint = /** @type {(inputs: Sms_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gateway status and admin test send.`)
};

/**
* | output |
* | --- |
* | "Gateway status and admin test send." |
*
* @param {Sms_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sms_hint = /** @type {((inputs?: Sms_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sms_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sms_hint(inputs)
	return cs_sms_hint(inputs)
});